export default {
  GetTaxcodeList(state) {
    return state.taxcodeList;
  },
  GetTaxcodeObject(state) {
    return state.currentTaxcodeObject;
  }
};
